module.exports = __webpack_public_path__ + "img/Kitemill om sikker energiforsyning og bærekraft.b5bac464.png";